import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import get from 'lodash/get';

import { DescriptionItem, DescriptionList } from 'components/DescriptionList';

const BusinessPartnerContacts = ({ data }: { data: any }) => {
  return (
    <DescriptionList
      data={get(data, 'businessPartner.details.affiliateContact')}
    >
      <IonGrid>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'partyName'} label={'Company Name'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'partyNameShort'} label={'AKA'} />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'address.countryName'} label={'Country'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'address.region'}
              label={'State/Province/Region'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'address.city'} label={'City'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'address.zipCode'}
              label={'Zip/Postal Code'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'address.addressLine1'}
              label={'Address Line 1'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'address.addressLine2'}
              label={'Address Line 2'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'contact.mobilePhone'} label={'Mobile'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'contact.phone'} label={'Phone'} />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'contact.email'} label={'Email'} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </DescriptionList>
  );
};

export default BusinessPartnerContacts;
